<template>
    <modal v-if="modalPlay" v-model:show="showModal" :showClose="false" :clickClose="false">
        <template v-slot:header>
            <h5 class="modal-title">You are about to resume the entries </h5>
        </template>
        <form id="my-form">
            <div>
                <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">Users:</label>
                <base-input name="selectmultiple" class="w-100 mr-2">
                    <el-select v-model="tempUserIds" multiple filterable :collapse-tags="shouldCollapseTags"
                        placeholder="Select Users" @change="handleSelectAll('user', $event)">
                        <el-option :key="'select_all'" :label="getSelectAllLabel('user')"
                            value="select_all"></el-option>
                        <el-option v-for="option in sortedSelectOptions" :key="option.key" :label="option.value"
                            :value="option.key">
                        </el-option>
                    </el-select>
                </base-input>
            </div>
            <div>
                <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">Brokers:</label>
                <base-input name="selectmultiple" class="w-100 mr-2">
                    <el-select v-model="tempBrokers" multiple filterable :collapse-tags="shouldCollapseTagsBrokers"
                        placeholder="Select Brokers" @change="handleSelectAll('broker', $event)">
                        <el-option :key="'select_all_brokers'" :label="getSelectAllLabel('broker')"
                            value="select_all_brokers"></el-option>
                        <el-option v-for="option in sortedBrokerOptions" :key="option.key" :label="option.value"
                            :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
            </div>
            <div>
                <base-checkbox v-model="check">
                    Resume All
                </base-checkbox>
            </div>
        </form>
        <div class="mt-4 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
            <button class="btn btn-primary" type="button" @click="playModal()">Play</button>
        </div>
        <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
            <small class="text-danger">{{ errorMessage }}</small>
        </div>
    </modal>
    <modal v-model:show="showVerifyModal" :showClose="false" :clickClose="false">
        <form>
            <div class="mb-3">
                <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
            </div>
            <div class="mb-3">
                <label for="user-input"
                    class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
                    please enter the provided number:
                </label>
                <input type="text" v-model="userInput"
                    class="form-control d-flex justify-content-center align-item-center" id="user-input" maxlength="3"
                    placeholder="Enter 3-digit number" />
            </div>
        </form>
        <div class="mt-4 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" @click="goToPrevious()">Edit</button>
            <button class="btn btn-primary" type="button" @click="validateInput();">Verify</button>
        </div>
        <div class="mt-3 d-flex justify-content-center">
            <small class="text-danger">{{ validationMessage }}</small>
        </div>
        <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
            <small class="text-danger">{{ errorMessage }}</small>
        </div>
    </modal>
</template>
<script>
import {
    ElSelect,
    ElOption,
    ElInput,
} from "element-plus";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import BaseCheckbox from "@/components/Inputs/BaseCheckbox.vue";
export default {
    name: "ModalPlay",
    components: {
        Modal,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElInput.name]: ElInput,
        BaseCheckbox,
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        modalPlay: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            errorFlag: false,
            tempUserIds: [],
            tempBrokers: [],
            selectOptions: [],
            brokerOptions: [],
            showVerifyModal: false,
            randomNum: '',
            userInput: "",
            validationMessage: "",
            play: {
                playStatus: "PLAY",
            },
            check: false,
        };
    },
    computed: {
        shouldCollapseTags() {
            const allUserIds = this.selectOptions.map(option => option.key);
            return this.tempUserIds.length > 10 || this.tempUserIds.length === allUserIds.length;
        },
        sortedSelectOptions() {
            return [...this.selectOptions].sort((a, b) => {
                const isASelected = this.tempUserIds.includes(a.key);
                const isBSelected = this.tempUserIds.includes(b.key);
                if (isASelected === isBSelected) {
                    return a.value.localeCompare(b.value);
                }
                return isASelected ? -1 : 1;
            });
        },
        shouldCollapseTagsBrokers() {
            const totalBrokers = this.brokerOptions.length;
            const isSelectAll = this.tempBrokers.length === totalBrokers;
            return isSelectAll && totalBrokers > 10;
        },
        sortedBrokerOptions() {
            return [...this.brokerOptions].sort((a, b) => {
                const isASelected = this.tempBrokers.includes(a.value);
                const isBSelected = this.tempBrokers.includes(b.value);
                if (isASelected === isBSelected) {
                    return a.value.localeCompare(b.value);
                }
                return isASelected ? -1 : 1;
            });
        }
    },
    methods: {
        getSelectAllLabel(type) {
            if (type === 'user') {
                const allUserIds = this.selectOptions.map(option => option.key);
                return this.tempUserIds.length === allUserIds.length ? 'Deselect All Users' : 'Select All Users';
            } else if (type === 'broker') {
                const allBrokers = this.brokerOptions.map(option => option.key);
                return this.tempBrokers.length === allBrokers.length ? 'Deselect All Brokers' : 'Select All Brokers';
            }
        },
        handleSelectAll(type, value) {
            let options = type === 'user' ? this.selectOptions : this.brokerOptions;
            let tempList = type === 'user' ? this.tempUserIds : this.tempBrokers;
            const selectAllKey = type === 'user' ? 'select_all' : 'select_all_brokers';
            const allKeys = type === 'user'
                ? options.map(option => option.key)
                : options.map(option => option.value);
            if (value.includes(selectAllKey)) {
                if (tempList.length === allKeys.length + 1) {
                    type === 'user' ? this.tempUserIds = [] : this.tempBrokers = [];
                } else {
                    type === 'user' ? this.tempUserIds = [...allKeys] : this.tempBrokers = [...allKeys];
                }
            } else {
                if (tempList.includes(selectAllKey)) {
                    type === 'user'
                        ? this.tempUserIds = this.tempUserIds.filter(v => v !== selectAllKey)
                        : this.tempBrokers = this.tempBrokers.filter(v => v !== selectAllKey);
                }
            }
        },
        closeModal() {
            this.errorFlag = false;
            this.tempUserIds = [];
            this.tempBrokers = [];
            this.check = false;
            this.validationMessage = "";
            this.userInput = "";
            this.$emit('updateParameters', false, false);
        },
        getRandomNumber() {
            this.randomNum = Math.floor(100 + Math.random() * 900);
        },
        playModal() {
            this.getRandomNumber();
            this.$emit("updateParameters", false, this.modalPlay);
            this.showVerifyModal = true;
        },
        goToPrevious() {
            this.showVerifyModal = false;
            this.$emit("updateParameters", true, this.modalPlay);
        },
        validateInput() {
            if (parseInt(this.userInput) === this.randomNum) {
                this.validationMessage = "";
                this.playEntry();
            } else {
                this.errorFlag = false;
                this.validationMessage = "Incorrect number. Please try again.";
            }
        },
        async playEntry() {
            this.errorFlag = false;
            var self = this;
            let data = {};
            let request = {
                "otp": "123",
                "userIds": self.tempUserIds,
                "brokers": self.tempBrokers,
                "pauseAll": !self.check
            }
            let variable = {
                "status": self.play.playStatus,
            }
            data.payload = request;
            data.param = variable;
            self.$store
                .dispatch("settingStore/playEntry", data, { root: true })
                .then(function (response) {
                    self.showVerifyModal = false;
                    self.check = false;
                    self.validationMessage = "";
                    self.userInput = "";
                    self.$emit('updateParameters', false, false);
                    swal.fire({
                        title: "Play Entry!",
                        text: "Request to play the entry is success.",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                        icon: "success",
                    });
                    self.tempUserIds = [];
                    self.tempBrokers = [];

                }).catch(function (error) {
                    self.errorFlag = true;
                    self.errorMessage = error.server;
                });
        },
        getActiveUsers() {
            let data = {
                type: 'active-users'
            };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        this.selectOptions = response.server.data;
                        sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        getActiveBrokers() {
            let data = {
                type: 'active-brokers'
            };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                this.brokerOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        this.brokerOptions = response.server.data;
                        sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.brokerOptions));
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
    },
    mounted() {
        this.getActiveUsers();
        this.getActiveBrokers();
    }
};
</script>